<template>
  <div>
    <div class="card" v-if="loading">
      <div class="card-body">
        <div class="text-center">
          <b-spinner class="ms-2" variant="primary"></b-spinner>
        </div>
      </div>
    </div>

    <div class="filtro-component" v-else>
      <b-card>
        <div class="row cursor-pointer" id="header-filtro" @click="filtroExpandido = !filtroExpandido">
          <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center">
            <h4 class="font-size-16 mb-0" style="font-weight: 600;">FILTRO DE PROJETOS</h4>
          </div>
          
          <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row justify-content-md-end order-1 order-md-2 mb-2 mb-md-0">
            <b-button @click.stop="importarCSV" variant="warning" class="me-md-3 mb-2 mb-md-0"><i class="fa fa-solid fa-upload"></i> Importar CSV</b-button>
            <b-button @click.stop="novoProjeto" variant="success" style="margin-right: 15px;"><i class="fa fa-solid fa-plus"></i> Novo Projeto</b-button>  
            <i :class="filtroExpandido ? 'mdi mdi-filter' : 'mdi mdi-filter-outline'" class="icone-accordion"></i>
          </div>
        </div>

        <b-collapse id="accordion-filtros" v-model="filtroExpandido" class="mt-3">
          <hr>
          <div class="row d-flex mb-1">
            <div class="col-md-3">
              <b-form-group label="Cooperado">
                <multiselect 
                  v-model="selecaoCooperado" 
                  :options="cooperadoLkp" 
                  label="name"
                  track-by="name"
                  placeholder="Selecione"
                  :allowEmpty="false"
                  :taggable="false"
                  select-label=""
                  @input="carregarClienteRural"
                  :max-height="200"
                >
                  <span slot="noOptions">Nenhum Cooperado disponível</span>
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Cliente Rural">
                <multiselect
                  v-model="selecaoClienteRural"
                  :options="clienteRuralLkp"
                  label="name"
                  track-by="name"
                  placeholder="Selecione"
                  select-label=""
                  :loading="loadingClienteRural"
                  :max-height="200"
                >
                  <span slot="noOptions">Nenhum Cliente Rural disponível</span>
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Instituição Financeira">
                <multiselect v-model="selecaoInstituicaoFinanceira" :loading="loadingInstFinanceira" :options="instituicaoFinanceiraLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="200"/>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Linha de Crédito">
                <multiselect v-model="selecaoLinhaCredito" :options="linhaCreditoLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="200"/>
              </b-form-group>
            </div>
          </div>
          <div class="row d-flex mb-1">
            <div class="col-md-3">
              <b-form-group label="Safra">
                <multiselect v-model="selecaoSafra" :options="selecaoSafraLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="200" @input="carregarItemAgropecuario" :class="{ 'is-invalid': safraObrigatoria }"/>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Tipo de Projeto">
                <multiselect
                  v-model="selecaoTipoProjeto"
                  :options="tipoProjetoLkp"
                  label="name"
                  track-by="name"
                  placeholder="Selecione"
                  select-label=""
                  @input="carregarItemAgropecuario"
                  :max-height="200"
                  :class="{ 'is-invalid': tpProjetoObrigatorio }"
                >
                  <span slot="noOptions">Nenhum Tipo de Projeto disponível</span>
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Item Agropecuário">
                <multiselect v-model="selecaoItemAgropecuario" :options="itemAgropecuarioLkp" :loading="loadingItemAgropecuario" label="name" track-by="name" placeholder="Selecione" :max-height="200" select-label="" 
                  @open="validaSafraTpProjetoObrigatorio"
                  @close="safraObrigatoria = false; tpProjetoObrigatorio = false;">
                  <span slot="noOptions">Lista vazia, selecione a safra e tipo de projeto.</span>
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="N° Projeto">
                <b-form-input v-model="numeroProjeto" v-mask="'########'" :maxlength="8"  type="text" />
              </b-form-group>
            </div>
          </div>
          <div class="row d-flex mb-1">
            <div class="col-md-3">
              <b-form-group label="Projeto Unicampo">
                <multiselect v-model="selecaoProjeto" :options="selecaoProjetoLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="150"/>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Município - UF">
                <multiselect v-model="selecaoMunicipio" :options="selecaoMunicipioLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="150"/>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Modalidade do Seguro">
                <multiselect v-model="selecaoModalidadeSeguro" :options="selecaoModalidadeSeguroLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="150"/>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Status">
                <multiselect v-model="selecaoStatusProjeto" :options="selecaoStatusProjetoLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="150"/>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1">
              <b-button variant="secondary" class="me-md-3 mb-2 mb-md-0" @click="limpar">
                <i class="mdi mdi-broom"></i> Limpar
              </b-button>
              <b-button variant="primary" @click="emitirFiltro" :disabled="disabledFiltro">
                <i class="mdi mdi-filter-outline"></i> Filtrar
                <b-spinner
                  variant="secondary"
                  small
                  class="ms-2"
                  v-if="disabledFiltro"
                ></b-spinner>
              </b-button>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>

    <modalImportacao ref="modalImportacao" @errosImportacao="mostrarErrosImportacao"/>

    <modalErrosImportacao ref="modalErrosImportacao" :erros="errosImportacao"/>

  </div>
</template>

<script>
import Multiselect          from "vue-multiselect";
import clienteRuralMixin    from "@/tools/mixins/clienteRuralMixin.js";
import modalImportacao      from "@/components/astec/projetos/lotesImportacao/modalImportacao";
import modalErrosImportacao from "@/components/astec/projetos/lotesImportacao/modalErrosImportacao";

export default {
  mixins    : [clienteRuralMixin],
  components: { Multiselect, modalImportacao, modalErrosImportacao },
  data() {
    return {
      loading                     : true,
      numeroProjeto               : "",
      selecaoClienteRural         : null,
      selecaoMunicipio            : null,
      selecaoProjeto              : null,
      selecaoSafra                : null,
      selecaoInstituicaoFinanceira: null,
      selecaoLinhaCredito         : null,
      selecaoTipoProjeto          : null,
      selecaoItemAgropecuario     : null,
      selecaoModalidadeSeguro     : null,
      selecaoStatusProjeto        : null,
      selecaoCooperado            : null,
      clienteRuralLkp             : [],
      instituicaoFinanceiraLkp    : [],
      linhaCreditoLkp             : [],
      tipoProjetoLkp              : [],
      selecaoSafraLkp             : [],
      selecaoMunicipioLkp         : [],
      selecaoProjetoLkp           : [],
      itemAgropecuarioLkp         : [],
      selecaoStatusProjetoLkp     : [],
      selecaoModalidadeSeguroLkp  : [],
      cooperadoLkp                : [],
      loadingInstFinanceira       : false,
      cdPessoa                    : "",
      disabledFiltro              : false,
      loadingItemAgropecuario     : false,
      loadingClienteRural         : false,
      carregou                    : false,
      filtroExpandido             : true,
      errosImportacao             : null,
      safraObrigatoria            : false,
      tpProjetoObrigatorio        : false,
    };
  },
  async mounted() {
    await this.buscarDados();

    if(this.$store.state.filtroProjetoAstec){
      await this.verificarFiltro(this.$store.state.filtroProjetoAstec)
    }else {
      const statusProjeto = this.selecaoStatusProjetoLkp.find(el => el.value === 'E');

      this.selecaoStatusProjeto = statusProjeto;

      this.emitirFiltro();
    }
  },
  methods: {
    async buscarDados() {
      await this.getNomeRazaoUsuario();
      await this.buscarMunicipioUf();
      await this.buscarLkpProjeto();
      await this.buscarLkpSafra();
      await this.buscarLkpLinhaCredito();
      await this.buscarLkpTipoProjeto();
      await this.buscarLkpModalidadeSeguro();
      await this.buscarLkpStatusProjeto(); 
      await this.buscarLkpCooperado();
      await this.verificarCooperado();
      await this.carregarClienteRural();

      this.loading = false;
    },

    async carregarClienteRural(){
      if(this.selecaoCooperado){
        this.clienteRuralLkp     = [];
        this.selecaoClienteRural = null;
        this.loadingClienteRural = true;

        try {
          const response = await this.$http.get("/api/astec/getLkpClienteRuralProjetos/" + this.selecaoCooperado.value);

          this.clienteRuralLkp = response.data.map(cliente => {
            return {
              name   : cliente.DISPLAY,
              value  : cliente.ID,
              cpfCnpj: cliente.NRCPFCNPJ,
            };
          });
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }
        
        this.loadingClienteRural = false;
        this.carregarInstFinanceira();
      }
    },
    
    async verificarFiltro(filtro) {
      this.selecaoCooperado = this.cooperadoLkp.find(
        (el) => el.value == filtro.cdCooperado
      );

      await this.carregarClienteRural()
      
      this.selecaoClienteRural = this.clienteRuralLkp.find(
        (el) => el.value == filtro.sqCliente
      );
      
      this.selecaoLinhaCredito = this.linhaCreditoLkp.find(
        (el) => el.value == filtro.cdLinhaCredito
      );
      
      this.selecaoTipoProjeto = this.tipoProjetoLkp.find(
        (el) => el.value == filtro.sqTpProjeto
      );
      
      this.selecaoSafra = this.selecaoSafraLkp.find(
        (el) => `'${el.name}'` == filtro.cdSafra
      );
      
      this.selecaoItemAgropecuario = this.itemAgropecuarioLkp.find(
        (el) => el.value == filtro.cdItemAgropecuario
      );
      
      this.selecaoModalidadeSeguro = this.selecaoModalidadeSeguroLkp.find(
        (el) => el.value == filtro.sqModalidadeSeguro
      );
      
      this.selecaoStatusProjeto = this.selecaoStatusProjetoLkp.find(
        (el) => `'${el.value}'` == filtro.stProjeto
      );

      this.numeroProjeto = filtro.nrProjeto || "";
      
      this.selecaoProjeto = this.selecaoProjetoLkp.find(
        (el) => el.value == filtro.cdProjeto
      );
      
      this.selecaoMunicipio = this.selecaoMunicipioLkp.find(
        (el) => el.value == filtro.sqRegiao
      );

      if (this.selecaoCooperado) {
        await this.carregarInstFinanceira();
      
        this.selecaoInstituicaoFinanceira = this.instituicaoFinanceiraLkp.find(
          (el) => el.value == filtro.cdInstituicaoFinanceira
        );
      }
      
      if (this.selecaoTipoProjeto && this.selecaoSafra) {
        await this.carregarItemAgropecuario();
      
        this.selecaoItemAgropecuario = this.itemAgropecuarioLkp.find(
          (el) => el.value == filtro.cdItemAgropecuario
        );
      }
      
      this.emitirFiltro();
    },

    async verificarCooperado() {
      if(this.cooperadoLkp.length == 1){
        this.$set(this, 'selecaoCooperado', this.cooperadoLkp[0]);
      } else {
        const cooperadoEncontrado = this.cooperadoLkp.find(cooperado => cooperado.value === this.cdPessoa);

        if (cooperadoEncontrado) {
          this.selecaoCooperado = cooperadoEncontrado;
          await this.carregarInstFinanceira();
        } else {
          console.log("Cooperado não encontrado ou lista vazia");
          this.selecaoCooperado = null;
        }
      }
    },

    limpar() {
      this.selecaoClienteRural          = null;
      this.selecaoMunicipio             = null;
      this.selecaoProjeto               = null;
      this.selecaoSafra                 = null;
      this.selecaoInstituicaoFinanceira = null;
      this.selecaoLinhaCredito          = null;
      this.selecaoTipoProjeto           = null;
      this.selecaoItemAgropecuario      = null;
      this.numeroProjeto                = "";
      this.selecaoModalidadeSeguro      = null;
      this.selecaoStatusProjeto         = null;

      this.$store.commit("PARAMETROS_FILTRO_PROJETO_ASTEC", null);
    },

    async emitirFiltro() {
      if (this.selecaoCooperado) {
        this.disabledFiltro = true;
      
        const filtro = this.montarObjetoFiltro();
      
        this.$store.commit("PARAMETROS_FILTRO_PROJETO_ASTEC", filtro);
      
        this.$emit('projetoAstecFiltrados', filtro, () => {
          this.disabledFiltro = false;
        });

        if(this.carregou){
          this.filtroExpandido = false;
        }else{
          this.carregou = true;
        }
      } else {
        this.$bvToast.toast('Selecione um cooperado para filtrar os projetos', {
          title  : 'Atenção',
          variant: 'warning',
          solid  : true,
        });
      }
    },

    async carregarInstFinanceira(){
      this.instituicaoFinanceiraLkp     = [];
      this.selecaoInstituicaoFinanceira = null;
      this.loadingInstFinanceira        = true;
      
      await this.buscarLkpInstituicaoFinanc(this.selecaoCooperado.value);
      
      this.loadingInstFinanceira        = false;
    },
    
    montarObjetoFiltro() {
      const dados = {
        sqCliente              : this.selecaoClienteRural          ? this.selecaoClienteRural.value          : null,
        sqRegiao               : this.selecaoMunicipio             ? this.selecaoMunicipio.value             : null,
        cdProjeto              : this.selecaoProjeto               ? this.selecaoProjeto.value               : null,
        cdSafra                : this.selecaoSafra                 ? `'${this.selecaoSafra.name}'`           : null,
        cdInstituicaoFinanceira: this.selecaoInstituicaoFinanceira ? this.selecaoInstituicaoFinanceira.value : null,
        cdLinhaCredito         : this.selecaoLinhaCredito          ? this.selecaoLinhaCredito.value          : null,
        sqTpProjeto            : this.selecaoTipoProjeto           ? this.selecaoTipoProjeto.value           : null,
        cdItemAgropecuario     : this.selecaoItemAgropecuario      ? this.selecaoItemAgropecuario.value      : null,
        sqModalidadeSeguro     : this.selecaoModalidadeSeguro      ? this.selecaoModalidadeSeguro.value      : null,
        stProjeto              : this.selecaoStatusProjeto         ? `'${this.selecaoStatusProjeto.value}'`  : null,
        cdCooperado            : this.selecaoCooperado             ? this.selecaoCooperado.value             : null,
        nrProjeto              : this.numeroProjeto                ? this.numeroProjeto                      : null,
      };

      return dados;
    },

    async carregarItemAgropecuario(){
      if(this.selecaoTipoProjeto && this.selecaoSafra){
        this.selecaoItemAgropecuario = null;
        this.loadingItemAgropecuario = true;

        try {
          const response = await this.$http.get("/api/astec/getLkpItemAgropecuario/" + this.selecaoTipoProjeto.value + "/" + this.selecaoSafra.epoca);
        
          this.itemAgropecuarioLkp = response.data.map(itemAgropecuario => ({
            name : itemAgropecuario.DISPLAY,
            value: itemAgropecuario.ID,
          }));
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }
        
        this.loadingItemAgropecuario = false;
      } else {
        this.selecaoItemAgropecuario = null;
        this.itemAgropecuarioLkp     = [];
      }
      
      return;
    },

    importarCSV() {
      this.$refs.modalImportacao.abrirModal();
    },
    
    mostrarErrosImportacao(errosImportacao){
      this.errosImportacao = errosImportacao;

      this.$refs.modalErrosImportacao.abrirModalErrosImport();
    }, 

    novoProjeto() {
      localStorage.setItem('exibirCamposImportacao', false);
      this.$router.push("/astec/projetos/novoProjeto");
    }, 

    validaSafraTpProjetoObrigatorio() {
      if(this.selecaoSafra != null){
        this.safraObrigatoria = false;
      }else{
        this.safraObrigatoria = true;
      }

      if(this.selecaoTipoProjeto != null){
        this.tpProjetoObrigatorio = false;
      }else{
        this.tpProjetoObrigatorio = true;
      }
    },
  }
};
</script>

<style scoped>
  .icone-accordion{
    font-size: 24px;
  }
</style>
